import consts from "consts"
import FormatterHelper from "helpers/formatter"
import { getAPIEnv } from "helpers/api"

// @dev we want to create special types of canonical links for some program pages
// there is no actual relation between those programs => channels except of manual redirects we have
export const generateCanonicalLink = ({ locale, programId, channelId, programSlug }) => {
  switch (programId) {
    case "209828":
      return `${consts.externalLink.landing}/${locale}/c/781/les-anges-de-la-télé-réalité`
    case "6136259":
      return `${consts.externalLink.landing}/${locale}/c/770/ardivision`
    case "287":
      return `${consts.externalLink.landing}/${locale}/c/780/les-zamours`
    case "6133573":
      return `${consts.externalLink.landing}/${locale}/c/792/mango-c-est-pas-sorcier`
    default:
      let landing = GetLanding()
      return `${landing}${FormatterHelper.basic(consts.routes.program, {
        locale,
        programId,
        channelId,
        programSlug,
      })}`
  }
}

export function GetLanding() {
  let env = getAPIEnv(consts.config.apiPath)

  switch (env) {
    case "local":
      return "http://127.0.0.1:3003"
    case "dev":
      return "https://www-dev.molotov.tv"
    case "staging":
      return "https://www-staging.molotov.tv"
    case "prod":
      return "https://www.molotov.tv"
    default:
      return "https://www.molotov.tv"
  }
}
